// Logo click: always land at the top of the home, also when already on it.
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export default scrollToTop;
